import { render } from "./model.vue?vue&type=template&id=001b4ff1&scoped=true"
import script from "./model.vue?vue&type=script&lang=js"
export * from "./model.vue?vue&type=script&lang=js"

import "./model.vue?vue&type=style&index=0&id=001b4ff1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-001b4ff1"]])

export default __exports__